import urlConstants from '~/lib/constants/url.constants';
import { CacheTag } from '~/store/services/CacheTag';
import { ENUMERATION_CACHE_TIME } from '~/store/services/enumerations';

import api from '../api';

export type CreateNoteTemplateRequest = {
  templateTitle: string;
  providerTypes: string[];
  appointmentTypeLabels: string[];
} & NoteTemplateControlFlags;
type CreateNoteTemplateResponse = {
  id: string;
};
export type UpdateNoteTemplateRequest = {
  templateId: string;
  templateTitle: string;
  providerTypes: string[];
  appointmentTypeLabels: string[];
} & NoteTemplateControlFlags;

export const noteTemplatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    addNoteTemplate: build.mutation<
      CreateNoteTemplateResponse,
      CreateNoteTemplateRequest
    >({
      invalidatesTags: [{ type: CacheTag.NoteTemplates }],
      query: (req) => ({
        body: req,
        method: 'POST',
        url: urlConstants.clinical_data.noteTemplates,
      }),
    }),
    getNoteTemplates: build.query<NoteTemplate[], void>({
      keepUnusedDataFor: ENUMERATION_CACHE_TIME,
      providesTags: [CacheTag.NoteTemplates],
      query: () => ({
        method: 'GET',
        url: urlConstants.clinical_data.noteTemplates,
      }),
    }),
    updateNoteTemplate: build.mutation<
      { templateId: string },
      UpdateNoteTemplateRequest
    >({
      invalidatesTags: [
        { type: CacheTag.NoteTemplates },
        { type: CacheTag.NoteTemplateRevisions },
      ],
      query: (req) => ({
        body: req,
        method: 'PUT',
        url: urlConstants.clinical_data.updateNoteTemplate(req.templateId),
      }),
    }),
  }),
});

export const {
  useAddNoteTemplateMutation,
  useGetNoteTemplatesQuery,
  useUpdateNoteTemplateMutation,
} = noteTemplatesApi;
